// DEPENDENCIES //
// import { Routes, Route, Link } from "react-router-dom";
// import React, { useState } from 'react';
import './App.css';

// COMPONENTS //
import Header from "./components/Header";
import SlideshowWide from "./components/SlideshowWide";
import About from "./components/About";
import Comics from "./components/Comics";
import Tools from "./components/Tools";
import Games from "./components/Games";
// import GraphicArt from "./components/GraphicArt";
import Faq from "./components/Faq";
import SlideshowTJs from './components/SlideshowTJs';
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />

      <SlideshowWide />

      <About />

      <Comics />

      {/* <GraphicArt /> */}

      <Games />

      <Tools />

      <Faq />

      <Footer />

      <p className="credit">©2023-2026 A Planetary Shift</p>

    </div>
  );
}

export default App;
